import ChevronDown from './icon-chevron-down'
import ChevronRight from './icon-chevron-right'
import ChevronLeft from './icon-chevron-left'
import Close from './icon-close'
import Code from './icon-code'
import Article from './icon-content-type-article'
import Answer from './icon-content-type-answer'
import Discussion from './icon-content-type-discussion'
import Question from './icon-content-type-question'
import Idea from './icon-content-type-idea'
import Edit from './icon-edit'
import Email from './icon-email'
import ExternalLink from './icon-external-link'
import InsertPoll from './icon-insert-poll'
import MoreHoriz from './icon-more-horiz'
import Palette from './icon-palette'
import People from './icon-people'
import Platform from './icon-platform'
import Setting from './icon-setting'
import Loader from './loader'
import ArrowDropdown from './arrow-drop-down'
import ArrowDropUp from './icon-arrow-drop-up'
import Lock from './icon-lock'
import Sort from './icon-sort'

export default ({ icon, height, width, customClass, onClick }) => {
  let IconComponent
  switch (icon) {
    case 'code': IconComponent = Code; break
    case 'chevronDown': IconComponent = ChevronDown; break
    case 'chevronRight': IconComponent = ChevronRight; break
    case 'chevronLeft': IconComponent = ChevronLeft; break
    case 'close': IconComponent = Close; break
    case 'article' : IconComponent = Article; break
    case 'answer' : IconComponent = Answer; break
    case 'discussion' : IconComponent = Discussion; break
    case 'question' : IconComponent = Question; break
    case 'idea' : IconComponent = Idea; break
    case 'edit' : IconComponent = Edit; break
    case 'email' : IconComponent = Email; break
    case 'externalLink' : IconComponent = ExternalLink; break
    case 'insertPoll' : IconComponent = InsertPoll; break
    case 'moreHoriz' : IconComponent = MoreHoriz; break
    case 'palette' : IconComponent = Palette; break
    case 'people' : IconComponent = People; break
    case 'platform' : IconComponent = Platform; break
    case 'setting' : IconComponent = Setting; break
    case 'loader' : IconComponent = Loader; break
    case 'arrowDropdown' : IconComponent = ArrowDropdown; break
    case 'arrowDropUp' : IconComponent = ArrowDropUp; break
    case 'lock' : IconComponent = Lock; break
    case 'sort' : IconComponent = Sort; break
  }
  return <IconComponent height={height} width={width} customClass={customClass} onClick={onClick} />
}
